import React from "react"
import { Button } from "react-bootstrap"

import { ToggleOption } from "@/onboarding/features/bidding/types"

type Props = {
  subject: string
  options: [ToggleOption, ToggleOption]
  selected: boolean | undefined
  onChange: (selected: boolean | undefined) => void
  disabledReason: string | undefined
}

const PermissionToggle = ({ subject, options, selected, onChange, disabledReason }: Props) => (
  <div className="d-flex gap-2" title={disabledReason}>
    {options.map((option) => (
      <Button
        key={option.label}
        size="sm"
        variant={selected === option.value ? "primary" : "outline-primary"}
        aria-pressed={selected === option.value}
        aria-label={`${subject}: ${option.label}`}
        disabled={disabledReason !== undefined}
        onClick={() => onChange(selected === option.value ? undefined : option.value)}
      >
        {option.label}
      </Button>
    ))}
  </div>
)

export default PermissionToggle
